// Rankings do servidor (decisão do Arthur): level/XP, cada skill, outfits, montarias e gold.
export const HS_CATEGORIES = [
  ['week', 'Ranking semanal (XP da semana)'], ['experience', 'Experiência (level)'], ['magic', 'Magic level'], ['fist', 'Fist fighting'], ['club', 'Club fighting'],
  ['sword', 'Sword fighting'], ['axe', 'Axe fighting'], ['distance', 'Distance fighting'], ['shielding', 'Shielding'], ['fishing', 'Fishing'],
  ['outfits', 'Outfits (1 ponto + 1 por addon)'], ['mounts', 'Montarias (1 ponto cada)'], ['gold', 'Gold (banco + moedas)'],
] as const;
export type HsCategory = (typeof HS_CATEGORIES)[number][0];
export interface HsRow { rank: number; name: string; vocation: string; promotion: number; level: number; value: number; resets?: number }
